import { lazy } from 'react';

const ReactYoutubeLazy = lazy(() => import('react-youtube'));

export default ReactYoutubeLazy;
